import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Container } from "react-bootstrap";



const Template = ({ children }) => {


    return (
        <>
            <Header></Header>
            <div id='main' >
                <Container fluid className="container-body">
                    {children}
                </Container>
               {/* <Footer />*/}
            </div>
        </>



    )

}

export default Template;